import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsobaZanimanje } from './osoba-zanimanje';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osoba-zanimanje-modal-update',
  templateUrl: './osoba-zanimanje-modal-update.component.html'
})
export class OsobaZanimanjeModalUpdateComponent extends BaseModalUpdateComponent<OsobaZanimanje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaZanimanje>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
